var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1716_4071",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1716_4071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7315 10.609H15.5134V9.35896H11.7315V10.609ZM11.7315 8.20521H15.5134V6.95521H11.7315V8.20521ZM4.48794 13.0448H10.5775V12.7469C10.5775 12.1913 10.3027 11.7549 9.75294 11.4375C9.20336 11.1201 8.46329 10.9615 7.53273 10.9615C6.60218 10.9615 5.86204 11.1201 5.31232 11.4375C4.76273 11.7549 4.48794 12.1913 4.48794 12.7469V13.0448ZM7.53273 9.87187C7.9376 9.87187 8.28183 9.73 8.56544 9.44625C8.84919 9.16264 8.99107 8.8184 8.99107 8.41354C8.99107 8.00854 8.84919 7.66424 8.56544 7.38063C8.28183 7.09701 7.9376 6.95521 7.53273 6.95521C7.12787 6.95521 6.78357 7.09701 6.49982 7.38063C6.21621 7.66424 6.0744 8.00854 6.0744 8.41354C6.0744 8.8184 6.21621 9.16264 6.49982 9.44625C6.78357 9.73 7.12787 9.87187 7.53273 9.87187ZM3.59044 16.25C3.16947 16.25 2.81315 16.1042 2.52148 15.8125C2.22982 15.5208 2.08398 15.1645 2.08398 14.7435V5.25646C2.08398 4.83549 2.22982 4.47917 2.52148 4.1875C2.81315 3.89583 3.16947 3.75 3.59044 3.75H16.4109C16.8318 3.75 17.1882 3.89583 17.4798 4.1875C17.7715 4.47917 17.9173 4.83549 17.9173 5.25646V14.7435C17.9173 15.1645 17.7715 15.5208 17.4798 15.8125C17.1882 16.1042 16.8318 16.25 16.4109 16.25H3.59044ZM3.59044 15H16.4109C16.475 15 16.5338 14.9733 16.5871 14.9198C16.6406 14.8665 16.6673 14.8077 16.6673 14.7435V5.25646C16.6673 5.19229 16.6406 5.13354 16.5871 5.08021C16.5338 5.02674 16.475 5 16.4109 5H3.59044C3.52628 5 3.46753 5.02674 3.41419 5.08021C3.36072 5.13354 3.33398 5.19229 3.33398 5.25646V14.7435C3.33398 14.8077 3.36072 14.8665 3.41419 14.9198C3.46753 14.9733 3.52628 15 3.59044 15Z",
    fill: "#342E37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id_card.7d75dc5507a81a7ed57dea8ea65fd023.svg";
export { ForwardRef as ReactComponent };